import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import AddEditProductCategory from "./AddEditProductCategory";
import * as actionTypes from "../../actionTypes";
import Input from "../2/Controls/Input";
import Window from "../2/Controls/Window";
import Button from "../2/Controls/Button";
import ExportButton from "../2/Controls/ExportButton";
import { exportFile } from "../../actions/DataExporter";

class CategoryList extends Component {
  constructor(props) {
    super(props);
    const showOnline =
      !!props.registration &&
      !!props.registration.registration &&
      props.registration.registration.hasOwnProperty("OMNIEnabled");
    this.state = {
      list: [],
      totalCount: 0,
      loading: false,
      page: 1,
      pageSize: 25,
      filter: { name: "", status: "active" },
      showAddCategory: false,
      selectedRow: null,
      showFilter: false,
      showOption: false,
      isFilterActive: false,

      showExportMessage: false,
      exportMessage: "",


      listPageSettings: {
        Type: "category",
        Title: "Category",
        API: "getProductCategories",

        Search: {
          showSearch: true,
          placeholder: "Search by category name",
          onSearch: this.onSearch,
          onRefresh: this.onRefreshClick,
          onFilterClick: () => this.setState({ showFilter: true }),
          isFilterActive: false
        },

        HeaderButtons: [
          { ButtonType: "Button", Type: "primary", Text: "New", Icon: "add", Action: "popup", PopupType: "category" },
          { ButtonType: "ImageButton", Type: "option", Text: "Options", Icon: "option", Action: "options" }
        ],

        Columns: [
          { Name: "Name", Type: "field", Columns: [{ Column: "Name" }] },

          { Name: "Sequence", Type: "field", Columns: [{ Column: "Sequence" }] },

          { Name: "Color", Type: "field", Columns: [{ Column: "Color", Type: "color" }] },

          { Name: "Image", Type: "field", Columns: [{ Column: "Image.Preview", Type: "image" }] },

          ...(showOnline ? [{ Name: "Online", Type: "field", Columns: [{ Column: "OMNIEnabled", Type: "yesno" }] }] : []),

          {
            Name: "Image",
            Type: "field",
            ShowInMobile: true,
            Columns: [{ Column: "Image.Preview", Type: "image" }]
          },

          {
            Name: "Name",
            Type: "field",
            ShowInMobile: true,
            Columns: [
              { Column: "Name", CSS: "bold" },
              { Column: "Sequence", Label: "Sequence" },
              ...(showOnline ? [{ Column: "OMNIEnabled", Type: "yesno", Label: "Show online" }] : [])
            ]
          }
        ],

        RowButtons: [
          { ButtonType: "ImageButton", Type: "edit", Text: "Edit", Icon: "edit", Action: "popup", PopupType: "category" },
          { ButtonType: "ImageButton", Type: "delete", Text: "Delete", Icon: "delete", Action: "delete" }
        ],

        Sort: [{ Column: "ActionOn", Order: "desc" }]
      }
    };
  }


    onRefreshClick = () => {

  this.setState({

    filter: {
      name: "",
      status: "active",
    },

    isFilterActive: false,
    page: 1

  }, this.loadData);

};

  componentDidMount() { this.loadData(); }

  loadData = async () => {
    this.setState({ loading: true });

    var page = this.state.page;
    var pageSize = this.state.pageSize;
    var from = (page - 1) * pageSize;

    try {

      var res = await this.props.getProductCategories(
        from,
        pageSize,
        this.state.filter.name,
        this.state.filter.status
      );

      var list = [];
      var totalCount = 0;

      if (res && res.hasOwnProperty("searchResult"))
        list = res.searchResult;

      if (res && res.hasOwnProperty("totalCount"))
        totalCount = res.totalCount;

      this.setState({
        list: list,
        totalCount: totalCount,
        loading: false
      });

    } catch (err) {

      console.error(err);
      this.setState({ loading: false });

    }
  };

  onSearch = (searchText) => {
    this.setState({
      filter: { ...this.state.filter, name: searchText },
      page: 1
    }, this.loadData);
  };

  onNextClick = () => {

    var totalPages =
      Math.ceil(this.state.totalCount / this.state.pageSize);

    if (this.state.page < totalPages) {

      this.setState(
        prev => ({ page: prev.page + 1 }),
        this.loadData
      );

    }
  };

  onPreviousClick = () => {

    if (this.state.page > 1) {

      this.setState(
        prev => ({ page: prev.page - 1 }),
        this.loadData
      );

    }
  };

  onFirstClick = () => {

    this.setState({ page: 1 }, this.loadData);

  };

  onLastClick = () => {

    var totalPages =
      Math.ceil(this.state.totalCount / this.state.pageSize);

    this.setState({ page: totalPages }, this.loadData);

  };

  onRecordsPerPageCountChange = (pageSize) => {

    this.setState({
      pageSize: Number(pageSize),
      page: 1
    }, this.loadData);

  };

  onHeaderButtonClicked = (btn) => {

    if (btn.Action === "filter") {

      this.setState({ showFilter: true });

    }

    else if (btn.Action === "popup") {

      this.setState({
        showAddCategory: true,
        selectedRow: null
      });

    }

    else if (btn.Action === "options") {

      this.setState({ showOption: true });

    }

  };

  onApplyFilter = () => {

    this.setState({
      isFilterActive: true,
      page: 1,
      showFilter: false
    }, this.loadData);

  };

  onRowButtonClicked = (btn, row) => {

    if (btn.Action === "popup") {

      this.setState({
        showAddCategory: true,
        selectedRow: row
      });

    }

    if (btn.Action === "delete") {

      this.setState({
        showDelete: true,
        selectedRow: row
      });

    }

  };

  deleteRecord = () => {
    console.log("selectedRow", this.state.selectedRow);

    this.props
      .deleteProductCategory(this.state.selectedRow.key)
      .then(() => {

        this.setState({
          showDelete: false,
          selectedRow: null
        }, this.loadData);

      });

  };

  onClearFilter = () => {

    this.setState({
      filter: {
        name: "",
        status: "active"
      },
      isFilterActive: false,
      page: 1,
      showFilter: false
    }, this.loadData);

  };

  handleExport = async (type) => {

    const registration = this.props.registration && this.props.registration.registration;
    const exportColumns = [
      { header: "Category", field: "Name" },
      { header: "Sequence", field: "Sequence" },
      ...(registration && registration.hasOwnProperty("OMNIEnabled")
        ? [{ header: "Online", field: "OMNIEnabled", type: "boolean" }]
        : []),
    ];

    try {

      const from = 0;
      const pageSize = 10000;

      const res =
        await this.props.getProductCategories(
          from,
          pageSize,
          this.state.filter.name,
          this.state.filter.status
        );

      let data = [];

      if (res && res.searchResult)
        data = res.searchResult;

      if (data.length > 0) {

        await exportFile({
          data: data,
          columns: exportColumns,
          fileType: type,
          title: "Category",
          landscape: true
        });

      } else {

        this.setState({
          showExportMessage: true,
          exportMessage: "No data available to export"
        });

      }

    } catch (error) {

      console.error(error);

      this.setState({
        showExportMessage: true,
        exportMessage: `Export failed: ${error.message}`
      });

    }

  };


  
onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};
  render() {

    return (
      <>

        <ListingPage
           {...this.props} 
          listPageSettings={{
            ...this.state.listPageSettings,

            Search: {
              ...this.state.listPageSettings.Search,
              isFilterActive: this.state.isFilterActive   // ✅ always latest value
            }

          }}
            onPageChange={this.onPageChange}
          list={this.state.list}
          loading={this.state.loading}
          totalItemsCount={this.state.totalCount}
          recordFrom={(this.state.page - 1) * this.state.pageSize}
          itemsCountPerPage={this.state.pageSize}
          onNextClick={this.onNextClick}
          onPreviousClick={this.onPreviousClick}
          onFirstClick={this.onFirstClick}
          onLastClick={this.onLastClick}
          onRecordsPerPageCountChange={this.onRecordsPerPageCountChange}
          onHeaderButtonClicked={this.onHeaderButtonClicked}
          onRowButtonClicked={this.onRowButtonClicked}
        />

        {this.state.showAddCategory && (

          <AddEditProductCategory

            {...this.props}

            productCategory={
              this.state.selectedRow
            }

            type={
              actionTypes.PRODUCT_CATEGORY
            }

            onSave={() =>

              this.setState(
                { showAddCategory: false },
                this.loadData
              )

            }

            onClose={() =>

              this.setState({
                showAddCategory: false
              })

            }

          />

        )}

        {this.state.showFilter && (

          <Window

            header="Filter"

            size="small"

            slide={true}

            onClose={() =>

              this.setState({
                showFilter: false
              })

            }

            onButtonClick={(action) => {

              if (
                action.toLowerCase() === "apply"
              ) {

                this.onApplyFilter();

              }

              else if (
                action.toLowerCase() === "clear"
              ) {

                this.onClearFilter();

              }

            }}

            buttons={[
              {
                Type: "secondary",
                Text: "Clear",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Apply",
                Align: "right"
              }
            ]}

          >

            <Input

              type="text"

              label="Name"

              value={this.state.filter.name}

              onChange={(value) =>

                this.setState({

                  filter: {

                    ...this.state.filter,
                    name: value

                  }

                })

              }

            />

            <Input

              type="select"

              label="Status"

              value={this.state.filter.status}

              onChange={(value) =>

                this.setState({

                  filter: {

                    ...this.state.filter,
                    status: value

                  }

                })

              }

            >

              <option value="active">Active</option>

              <option value="inActive">In Active</option>

              <option value="all">All</option>

            </Input>

          </Window>

        )}

        {this.state.showOption && (

          <Window

            header="Options" choiceList

            size="small"

            slide={true}

            onClose={() =>

              this.setState({
                showOption: false
              })

            }

          >

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                height: "200px"
              }}
            >

              <ExportButton

                onExport={(value) =>
                  this.handleExport(value)
                }

                loading={
                  this.state.loading
                }

              />

            </div>

          </Window>

        )}

        {this.state.showDelete && (
          <Window
            header={"Delete"}
            size="medium"
            modal={true}
            processing={
              this.state.deleting
            }
            onClose={() =>
              this.setState({
                showDelete: false
              })
            }
            onButtonClick={(buttonType) => {
              if (
                buttonType.toLowerCase() === "yes"
              ) {
                this.deleteRecord();
              } else {
                this.setState({
                  showDelete: false,
                  selectedRow: null
                });
              }
            }}
            buttons={[
              {
                Type: "secondary",
                Text: "No",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Yes",
                Align: "right"
              },
            ]}
          >
            <div>
              Are you sure you wish to delete this record?
            </div>
          </Window>
        )}

        {this.state.showExportMessage && (

          <Window

            header="Export"

            size="small"

            modal={true}

            onClose={() =>
              this.setState({
                showExportMessage: false
              })
            }

            buttons={[
              {
                Type: "primary",
                Text: "OK",
                Align: "right"
              }
            ]}

            onButtonClick={() =>
              this.setState({
                showExportMessage: false
              })
            }

          >

            <div>
              {this.state.exportMessage}
            </div>

          </Window>

        )}

      </>
    );
  }
}

export default CategoryList;